export const localStorageKeys = {
  REDIRECT_URL: "APP_REDIRECT_URL",
  redirect: "App[URLRedirect]",
  langCode: "langCode",
  needReloadForCookiebot: "App[needReloadForCookiebot]",
  SUOMI_SELECTED_WARD_SYNLAB_ID: "weilobjmnwfk",
  HAS_SELECTED_SUOMI_WARD: "bfqcbaxcfzph",
  RESULT_SINGLE_TEST_RESULT: "nfbzltdmjghi",
  RESULT_SINGLE_TEST_RESULT_HISTORY: "tcqmawuchhgj",
  RESULT_TEST_DETAIL: "grnhvdyjglek",
  RESULT_TEST_DETAIL_HISTORY: "hbmhxpmbcdbz",
  RESULT_SYNLAB_ID: "locvfggvdbgy",
  RESULT_HISTORY_TABLE: "bpy8lzurr6eTb8KV",
};

export const RESULT_PAGE = {
  SINGLE: "single",
  PANEL: "panel",
};
